'use strict';

module.exports = {
  general: require('./generalMatcher'),
  msem: require('./msemMatcher'),
};
